export const isStepInMap = (result) => result.result_type === 'location' && result.is_step_in_map;